import { Theme } from "./context";

export const getTheme = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("theme");
  }
  return "light";
};

export const setTheme = (theme: Theme) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("theme", theme);
  }
};

export const checkAndSetTheme = () => {
  let theme = getTheme() as Theme;

  if (theme === null) {
    theme = matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    setTheme(theme);
  }
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", theme);
  }
  return theme;
};
